import script from "./ShimmerLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShimmerLoader.vue?vue&type=script&setup=true&lang=ts"

import "./ShimmerLoader.vue?vue&type=style&index=0&id=859ff58e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.27_typescript@5.3.3__webpack@5.91.0_webpack-cli@5.1.4_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-859ff58e"]])

export default __exports__